import type { Id } from '@/infra/id'
import { type AvatarSubject, Avatar } from '@/components/Avatar'
import { Icon } from '@/components/Icon'
import { IconButton } from '@/components/IconButton'
import {
  Dropdown,
  DropdownItem,
  DropdownItemTitle,
} from '@/components/Dropdown'
import styles from './JobNoteItem.module.css'

export interface JobNoteItemProps {
  id: Id
  author: AvatarSubject
  displayName: string
  formattedTime: string
  role?: string
  mentions: string[]
  body: string
  canDelete: boolean
  onDelete: () => unknown
}

export function JobNoteItem({
  id,
  author,
  displayName,
  formattedTime,
  role,
  mentions,
  body,
  canDelete,
  onDelete,
}: JobNoteItemProps) {
  return (
    <div className={styles.root} data-test={`job-note-${id}`}>
      <div className={styles.header}>
        <span className={styles.avatar}>
          <Avatar subject={author} size={24} />
        </span>
        <div className={styles.meta}>
          <span className={styles.author} title={displayName}>
            {displayName}
          </span>
          <div className={styles.subline}>
            <span className={styles.time}>{formattedTime}</span>
            {role && <span className={styles.role}>{role}</span>}
          </div>
        </div>
        {canDelete && (
          <Dropdown
            autoDismiss
            testId={`job-note-menu-${id}`}
            button={
              <IconButton
                name="more"
                label="Note actions"
                className={styles.menu}
              />
            }
          >
            <DropdownItem icon={<Icon name="delete" />} onPress={onDelete}>
              <DropdownItemTitle>Delete</DropdownItemTitle>
            </DropdownItem>
          </Dropdown>
        )}
      </div>

      <p className={styles.body} data-private>
        {mentions.map((mention) => (
          <span key={mention} className={styles.mention} title={mention}>
            {mention}
          </span>
        ))}
        {body}
      </p>
    </div>
  )
}
